import * as api from '../../api';
import { router } from '../../router/index';

const report = {
  state: {
    dailyReportlogPage: {},
    params: {},
  },
  mutations: {
    //项目数据
    getDailyReportLogPage(state, data) {
      state.dailyReportlogPage = data;
    }
  },
  getters: {
    getDailyReportLogPage(state) {
      return state.dailyReportlogPage;
    }
  },
  actions: {
    getDailyReportlogAction({ commit }, params) {
      this.params = params;
      api.getDailyReportLogByIdResource(params).then(function (response) {
        commit("getDailyReportLogPage", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    }
  }
};

export default report;



// WEBPACK FOOTER //
// ./src/store/modules/report.js